var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgOutlinedCheck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 30,
    viewBox: "0 0 31 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.0014 0C6.73243 0 0 6.73243 0 15.0014C0 23.2703 6.73243 30 15.0014 30C23.2703 30 30.0109 23.2703 30.0109 15.0014C30.0109 6.73243 23.2703 0 15.0014 0ZM15.0014 2.71952C21.7961 2.71952 27.2834 8.20638 27.2834 15.0015C27.2834 21.7967 21.7965 27.2727 15.0014 27.2727C8.2062 27.2727 2.73025 21.7963 2.73025 15.0015C2.73025 8.20684 8.20666 2.71952 15.0014 2.71952ZM21.2024 9.3333C20.8394 9.32638 20.4885 9.46435 20.2275 9.71686L20.2249 9.7142L12.3541 17.2253L9.67722 14.567C9.41991 14.3112 9.07098 14.1684 8.70804 14.1705C8.34508 14.1725 7.99793 14.3192 7.74345 14.5779C7.48757 14.8354 7.3448 15.1841 7.34693 15.5471C7.34888 15.91 7.49555 16.2572 7.75446 16.5116L11.3876 20.0942C11.6403 20.3408 11.9791 20.4799 12.3323 20.4818C12.6855 20.484 13.0257 20.3488 13.2814 20.105L22.1086 11.6879C22.3719 11.4388 22.5252 11.0952 22.5348 10.7329C22.5442 10.3705 22.409 10.0192 22.1592 9.75677C21.9093 9.49414 21.5652 9.34178 21.203 9.33325L21.2024 9.3333Z",
    fill: "#92C34D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOutlinedCheck);
export default __webpack_public_path__ + "static/media/outlined-check.8a576ca6.svg";
export { ForwardRef as ReactComponent };